import { LogLevel } from "@azure/msal-browser";

function newConfig() {
    console.log(window.location.hostname)
    if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
      return devConfig;  
    } else if (window.location.hostname === "apps-test.cnm.edu") {
      return testConfig;
    }
  
    return prodConfig;
}

const devConfig = {
    auth: {
        clientId: "dcb62079-c9c6-4199-92c6-10a5a43d32c9",
        authority: "https://login.microsoftonline.com/f50e076b-86a5-45f3-87b0-3f4d0ec5e94e/",
        redirectUri: "http://localhost:3000/fast2"
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false,   // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        console.log(message);
                }
            }
        }
    }
};

const testConfig = {
    auth: {
        clientId: "c78e936c-15f6-45d9-8f79-16189023c375",
        authority: "https://login.microsoftonline.com/f50e076b-86a5-45f3-87b0-3f4d0ec5e94e/",
        redirectUri: "https://apps-test.cnm.edu/fast2"
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false,   // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        console.log(message);
                }
            }
        }
    }
};

const prodConfig = {
    auth: {
        clientId: "c6fda717-a541-4181-b212-312fa58c9d61",
        authority: "https://login.microsoftonline.com/f50e076b-86a5-45f3-87b0-3f4d0ec5e94e/",
        redirectUri: "https://apps.cnm.edu/fast2"
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false,   // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        console.log(message);
                }
            }
        }
    }
};

export const authConfig = newConfig();

export const loginRequest = {
    scopes: ["User.Read"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
